import React from "react";
import classes from "./suggestedProducts.module.css";
import SuggestedProduct from "../suggestedProduct/suggestedProduct";

const SuggestedProducts = (props) => {
  const { onNavigate, products } = props;

  const items = products.slice(0, 3).map((product) => (
    <li key={product.id} className={classes.item}>
      <SuggestedProduct product={product} onNavigate={onNavigate} />
    </li>
  ));

  return <ul className={classes.root}>{items}</ul>;
};

export default SuggestedProducts;
